import { AREAS, C } from "./constants";

const HINT = { 1: "Casi nada", 5: "Muchísimo" };

const PainRow = ({ area, value, onChange }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 py-4 border-b last:border-b-0" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-dolor-row-${area.code}`}>
    <div className="text-[15px] font-semibold" style={{ color: C.text }}>{area.name}</div>
    <div className="flex items-center gap-2" role="radiogroup" aria-label={`Dolor de ${area.name}`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = value === n;
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(area.code, n)}
            className="w-10 h-10 rounded-lg text-sm font-bold border transition-colors"
            style={active ? { background: C.green, color: "#fff", borderColor: C.green } : { background: "#fff", color: C.text, borderColor: "#CBD5CF" }}
            data-testid={`tablero-dolor-${area.code}-${n}`}
            title={HINT[n] || String(n)}
          >
            {n}
          </button>
        );
      })}
    </div>
  </div>
);

export const PainInput = ({ dolor, onChange }) => (
  <div data-testid="tablero-dolor-input">
    <div className="flex justify-between text-[12px] mb-1" style={{ color: "#5B6B64" }}>
      <span>¿Cuánto te duele hoy esta área?</span>
      <span>1 casi nada · 5 muchísimo</span>
    </div>
    <div className="rounded-xl bg-white px-4 sm:px-5 border" style={{ borderColor: "#E3E7E1" }}>
      {AREAS.map((a) => <PainRow key={a.code} area={a} value={dolor[a.code]} onChange={onChange} />)}
    </div>
  </div>
);
